import { useState } from "react";

import Status from "components/global/Status";
import EyetSVG from "assets/svgs/EyetSVG";
import EditTSvg from "assets/svgs/EditTSvg";
import CheckAllSVG from "assets/svgs/CheckAll";
import ArrowDownSvg from "assets/svgs/ArrowDownSvg";
import img from "assets/images/img2.jpg";
import TealPagination from "components/global/TealPagination";
import PageLimit from "components/global/PageLimit";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {setDocinventoryExtraDetails} from 'redux/slices/inventorySlice'
import { useQueryClient } from 'react-query';
import confirmBox from "utils/confirmBox";
import {deleteInventory} from  'redux/actions/inventoryActions'
import TrashSvg  from 'assets/svgs/TrashSvg'
import toast from 'react-hot-toast';

const InventoryTable = ({
  currentPage,
  setCurrentPage,
  setLimit,
  limit
}) => {

  const dispatch=useDispatch();
  const navigate=useNavigate();
    const { docs , pages ,docsCount, deleteLoading } = useSelector(state => state.inventory);
          const {user } = useSelector((state) => state.auth);

  const queryClient = useQueryClient();
  
  const [selectedRows, setSelectedRows] = useState([]);

const start = (currentPage - 1) * limit + 1;
const end = start + docs.length - 1;


  // const handleRowSelect = (id) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(id) ? prev.filter((n) => n !== id) : [...prev, id]
  //   );
  // };

  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     setSelectedRows(docs.map((item) => item.id));
  //   } else {
  //     setSelectedRows([]);
  //   }
  // };






  const handleDeleteInventory = async (ID) => {

  if (!user?.isSuperAdmin) {
    // User is not super admin
    toast.error("You are not authorized to delete this inventory.");
    return;
  }

  const title = 'Confirm Deletion';
  const message = 'Are you sure you want to delete this Inventory?';

  const onYesClick = async () => {
    await dispatch(deleteInventory(ID));
    queryClient.invalidateQueries(["fetch-all-inventory"]);
  };

  confirmBox({ title, message, onYesClick });
};

 



  function formatLabel(text = "") {
  return text
    .replace(/_/g, " ")       
    .split(" ")               
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");           
}

  return (
    <div className="w-full bg-white flex flex-col gap-2 pb-4 rounded-xl shadow-sm">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between w-full px-3 pt-3">
        <p className="text-dark1 font-semibold text-lg">All Inventories</p>
      </div>

      {/* Table */}
      <div className="overflow-x-auto maintable">
        <table className="w-full text-sm md:text-[15px] bg-white">
          <thead className="text-left border-b text-gray-600">
            <tr>
              {/* <th className="px-6 py-4 whitespace-nowrap">
                <label className="relative inline-block w-[16px] h-[16px]">
                  <input
                    type="checkbox"
                    checked={
                      selectedRows.length === docs.length &&
                      docs.length > 0
                    }
                    onChange={handleSelectAll}
                    className="peer appearance-none w-full h-full border border-gray3 rounded-[5px] checked:border-gray-800 cursor-pointer"
                  />
                  <span className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-0 peer-checked:opacity-100">
                    <CheckAllSVG className="w-4 h-4 text-primary" />
                  </span>
                </label>
              </th> */}
              <th className="px-3 py-4 whitespace-nowrap">No</th>
              <th className="px-3 py-4  whitespace-nowrap">ID Code</th>
              <th className="px-3 py-4  whitespace-nowrap">Customer Name</th>
              <th className="px-3 py-4  whitespace-nowrap">Project</th>
              <th className="px-3 py-4  whitespace-nowrap">Sector</th>
              <th className="px-3 py-4  whitespace-nowrap">Type</th>
              <th className="px-3 py-4  whitespace-nowrap">Plot No.</th>
              <th className="px-3 py-4  whitespace-nowrap">Number</th>
              <th className="px-3 py-4  whitespace-nowrap">Full Number</th>
              <th className="px-3 py-4  whitespace-nowrap">Status</th>
              <th className="px-3 py-4  whitespace-nowrap">Action</th>
            </tr>
          </thead>

          <tbody>
            {docs.map((row, index) => (
              <tr
              // onClick={() => navigate(`/app/inventory/${row?._id}`)}
                key={row._id}
                className={`border-b hover:bg-gray-50 transition ${
                  selectedRows.includes(row._id) ? "bg-[#F0FAFF]" : ""
                }`}
              >
                {/* Checkbox */}
                {/* <td className="px-6 py-4">
                  <label className="relative inline-block w-[16px] h-[16px]">
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row._id)}
                      onChange={() => handleRowSelect(row._id)}
                      className="peer appearance-none w-full h-full border border-gray3 rounded-[5px] checked:border-gray-800 cursor-pointer"
                    />
                    <span className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-0 peer-checked:opacity-100">
                      <CheckAllSVG className="w-4 h-4 text-primary" />
                    </span>
                  </label>
                </td> */}

                <td className="px-3 py-4  whitespace-nowrap">{row?.autoIncrementId}</td>
                <td className="px-3 py-4  whitespace-nowrap">{row?.fullNumber}</td>
                <td className="px-3 py-4  whitespace-nowrap">
                {row?.currentSale?.buyers?.map(b => b?.name).join(', ')}
                  {/* <div className="flex items-center gap-2">
                    <div className="w-[32px] h-[32px] border overflow-hidden rounded-full">
                      <img
                        src={img}
                        alt="user avatar"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    {}
                  </div> */}
                </td>
                <td className="px-3 py-4  whitespace-nowrap">{row?.project?.title}</td>
                <td className="px-3 py-4  whitespace-nowrap">{row?.sector?.title}</td>
                <td className="px-3 py-4  whitespace-nowrap  capitalize">{row.type}</td>
                <td className="px-3 py-4  whitespace-nowrap">{row.plotNumber}</td>
                <td className="px-3 py-4  whitespace-nowrap">{row.number}</td>
                <td className="px-3 py-4  whitespace-nowrap">{row.fullNumber}</td>
                <td className="px-3 py-4  whitespace-nowrap">
                  <Status status={formatLabel(row.status)} />
                </td>
                <td className="px-3 py-4  whitespace-nowrap">
                  <div className="flex flex-row gap-1.5 items-center">
  {row.status === "deleted" ? (
    <></>
  ) : (
    <>
     
      {  row.status === "not_assigned"?(<></>): row.status === "draft" ||(!row?.currentSale?.plan)? (
        <button
          onClick={() => navigate(`/app/inventory/${row?._id}/purchase-plan`)}
          className="w-fit px-4 py-2 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 transition"
        >
         Set Installment Plan
        </button>
      ) : (
        !(row.status === "full_paid" || row.status === "not_assigned") && (
          <button
            onClick={() => {
              navigate(`/app/inventory/${row?._id}/pay-inventory`);
              dispatch(setDocinventoryExtraDetails(row));
            }}
            className="w-fit px-4 py-2 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 transition"
          >
            Pay
          </button>
        )
      )}

      <div
        onClick={() => navigate(`/app/inventory/${row?._id}`)}
        className="px-2.5 py-2.5 rounded-lg bg-primary cursor-pointer"
      >
        <EyetSVG />
      </div>


 {user?.isSuperAdmin && (
                      <div
                        onClick={() => handleDeleteInventory(row?._id)}
                        className="w-fit px-2.5 py-2.5 rounded-lg bg-darkred cursor-pointer"
                      >
                        <TrashSvg />
                      </div>
                    )}
    
    </>
  )}
</div>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer (Pagination + Limit) */}
      <div className="flex flex-col sm:flex-row justify-between items-center w-full px-3 mt-4 gap-3">
              <TealPagination 
     
          totalPages={pages}
             currentPage={currentPage}
            setCurrentPage={setCurrentPage}
     />

        <div className="flex items-center gap-2">
        <p className="text-sm text-[#A8A8A8]">
  Showing {docsCount === 0 ? 0 : start} to {docsCount === 0 ? 0 : end} of {docsCount} entries
</p>

          <div className="w-[140px] h-[40px]">
            <PageLimit totalpages={docsCount || 10} limit={limit} setLimit={setLimit}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryTable;
